import { render, staticRenderFns } from "./principleDashboard.vue?vue&type=template&id=22b33b67&scoped=true&"
import script from "./principleDashboard.vue?vue&type=script&lang=js&"
export * from "./principleDashboard.vue?vue&type=script&lang=js&"
import style0 from "./principleDashboard.vue?vue&type=style&index=0&id=22b33b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b33b67",
  null
  
)

export default component.exports